export const OBJECT_TYPE_RECEIPT = "RECEIPT"